import baseIcons from '@assets/icons.svg'
import logoIcons from '@assets/logo-icons.svg'
import loaders from '@assets/loaders.svg'

export const LOGO_ICONS = {
  url: logoIcons,
  icons: ['eyemed-logo', 'aetna-logo', 'humana-logo', 'cigna-logo', 'eyemedplus-logo'],
} as const

export const BASE_ICONS = {
  url: baseIcons,
  icons: [
    'phone',
    'call-us',
    'chat',
    'faq',
    'email',
    'arrow-left',
    'close',
    'status-valid',
    'status-error',
    'checkmark',
    'chevron',
    'calendar',
    'shield',
    'triangle-alert',
    'glasses',
    'lenses',
    'contact-lens',
    'eyeexam',
    'circled-cross',
    'info',
    'success',
    'warning',
    'error',
    'info-bubble',
    'glasses-aviator',
    'contact-lenses',
    'camera',
    'clock',
    'trashcan',
    'pen',
    'upload',
    'circular-arrow',
  ],
} as const

export const LOADER_ICONS = {
  url: loaders,
  // brand specific loader icons are dynamic and always follow this pattern
  icons: ['loader-{{brand}}-light', 'loader-{{brand}}-dark'],
} as const

export const SVG_LIBRARY = {
  base: BASE_ICONS,
  logos: LOGO_ICONS,
  loaders: LOADER_ICONS,
} as const
